/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusKundeOfferListResponseDto } from '../../models/lexplus-kunde-offer-list-response-dto';
import { LexplusKundeStatusEnum } from '../../models/lexplus-kunde-status-enum';

export interface KundenControllerFindAllZusatzauftraegePaginatedV1$Params {

/**
 * Lists the orders of Kunden in these statuses.
 */
  kundeStatus?: Array<LexplusKundeStatusEnum>;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by status query param.
 *
 * **Format:** filter.status={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.status=$eq:John Doe&filter.status=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.status'?: Array<string>;

/**
 * Filter by projectManagerID query param.
 *
 * **Format:** filter.projectManagerID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.projectManagerID=$eq:John Doe&filter.projectManagerID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.projectManagerID'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=bearbeitetAm:DESC&sortBy=offerID:DESC
 *
 *
 * **Default Value:** bearbeitetAm:DESC
 *
 * **Available Fields**
 * - bearbeitetAm
 *
 * - offerID
 *
 * - status
 *
 * - offerVolume
 *
 * - remark
 *
 * - kundeName
 *
 * - projektleiter
 *
 * - kundeStatus
 */
  sortBy?: Array<'bearbeitetAm:ASC' | 'bearbeitetAm:DESC' | 'offerID:ASC' | 'offerID:DESC' | 'status:ASC' | 'status:DESC' | 'offerVolume:ASC' | 'offerVolume:DESC' | 'remark:ASC' | 'remark:DESC' | 'kundeName:ASC' | 'kundeName:DESC' | 'projektleiter:ASC' | 'projektleiter:DESC' | 'kundeStatus:ASC' | 'kundeStatus:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;
}

export function kundenControllerFindAllZusatzauftraegePaginatedV1(http: HttpClient, rootUrl: string, params?: KundenControllerFindAllZusatzauftraegePaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusKundeOfferListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, kundenControllerFindAllZusatzauftraegePaginatedV1.PATH, 'get');
  if (params) {
    rb.query('kundeStatus', params.kundeStatus, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.status', params['filter.status'], {});
    rb.query('filter.projectManagerID', params['filter.projectManagerID'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusKundeOfferListResponseDto>;
    })
  );
}

kundenControllerFindAllZusatzauftraegePaginatedV1.PATH = '/v1/kunden/zusatzauftraege/paginated';
